import { useEffect, useState } from "react";
import { IoClose } from "react-icons/io5";

const EmployeeAccessModal = ({
    open,
    employee,
    modules,
    selectedModules,
    onSave,
    onClose, }) => {

    const [checked, setChecked] = useState([]);

    useEffect(() => {
        if (open) {
            setChecked(selectedModules || []);
        }
    }, [open, selectedModules]);

    if (!open || !employee) return null;

    const toggleModule = (id) => {
        setChecked(prev =>
            prev.includes(id)
                ? prev.filter(m => m !== id)
                : [...prev, id]
        );
    };

    const isAllSelected = modules.length > 0 && checked.length === modules.length;

    const toggleSelectAll = () => {
        if (isAllSelected) {
            setChecked([]);
        } else {
            setChecked(modules.map(m => m.id));
        }
    };

    const handleSave = () => {
        onSave(employee, checked);
    };

    return (
        <div className="admin-modal-overlay">
            <div className="admin-modal max-w-3xl">

                {/* MODAL HEADER */}
                <div className="admin-modal-header">
                    <div className="admin-modal-title">
                        Select Work Module ( {employee.name} {employee.surname} )
                    </div>
                    <button className="admin-modal-close" onClick={onClose}>
                        <IoClose />
                    </button>
                </div>

                {/* TABLE HEADER (FIXED) */}
                <div className="admin-table-header">
                    <table className="admin-table">
                        <thead>
                            <tr>
                                <th style={{ width: "80px" }} className="checkbox-select-all">
                                    <input
                                        type="checkbox"
                                        checked={isAllSelected}
                                        onChange={toggleSelectAll}
                                    />
                                </th>
                                <th>Module Name</th>
                            </tr>
                        </thead>
                    </table>
                </div>

                {/* SCROLLABLE TABLE BODY */}
                <div className="admin-table-body-access">
                    <table className="admin-table">
                        <tbody>
                            {modules.map((m) => (
                                <tr key={m.id}>
                                    <td style={{ width: "80px" }} className="text-center">
                                        <input
                                            type="checkbox"
                                            checked={checked.includes(m.id)}
                                            onChange={() => toggleModule(m.id)}
                                        />
                                    </td>
                                    <td>{m.name}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                {/* FOOTER */}
                <div className="admin-form-footer">
                    <button className="admin-btn-cancel" onClick={onClose}>
                        CANCEL
                    </button>
                    <button className="admin-btn-save" onClick={handleSave}>
                        SAVE
                    </button>
                </div>

            </div>
        </div>
    )
}

export default EmployeeAccessModal;
